export const CALENDAR_DAY_MS = 24 * 60 * 60 * 1000

export const utcDayKey = (value: Date | number) =>
  new Date(value).toISOString().slice(0, 10)

/** The full Monday-first grid occupied by a UTC month. The API fetch uses the
 * padded bounds too, so deliveries in the leading/trailing cells are present. */
export function calendarMonthRange(cursor: number) {
  const first = new Date(cursor)
  const year = first.getUTCFullYear()
  const month = first.getUTCMonth()
  const firstWeekday = (first.getUTCDay() + 6) % 7
  const gridStart = Date.UTC(year, month, 1) - firstWeekday * CALENDAR_DAY_MS
  const daysInMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate()
  const weeks = Math.ceil((firstWeekday + daysInMonth) / 7)
  const gridEnd = gridStart + (weeks * 7 - 1) * CALENDAR_DAY_MS

  return {
    year,
    month,
    gridStart,
    weeks,
    from: utcDayKey(gridStart),
    to: utcDayKey(gridEnd),
  }
}
